import React from 'react';

import { MagnifyingGlass } from 'react-loader-spinner';

import type { AnalyzingSpinnerProperties } from './AnalyzingSpinner.types';

export const AnalyzingSpinner: React.FC<AnalyzingSpinnerProperties> = ({
  size = '15',
  isLoading,
  mainColor = 'primary',
  secondColor = 'secondary',
}) => {
  const mainColorString = `var(--mui-palette-${mainColor}-main)`;
  const secondaryColorString = `var(--mui-palette-${secondColor}-main)`;
  return (
    isLoading && (
      <MagnifyingGlass
        width={size}
        height={size}
        color={mainColorString}
        glassColor={secondaryColorString}
      />
    )
  );
};
